import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatVolume } from './WhaleTradesPanel';

const ASSETS = ['BTC', 'ETH', 'SOL'];

function EtfFlowPanel({ etfFlows }) {
  const { t } = useTranslation();
  const [selectedDateIdx, setSelectedDateIdx] = useState(0);

  if (!etfFlows) {
    return (
      <div className="stats-panel stats-etf-panel">
        <div className="stats-panel-header">
          <span className="stats-panel-title">{t('stats.etfFlows')}</span>
        </div>
        <div className="stats-etf-empty">{t('stats.noEtfData')}</div>
      </div>
    );
  }

  const history = etfFlows.history || [];
  // Show up to 5 most recent dates as tabs
  const dateTabs = history.slice(0, 5);
  const selected = dateTabs[selectedDateIdx] || dateTabs[0];

  // Get flows for the selected date
  const flows = ASSETS.map((asset) => ({
    asset,
    value: selected?.[asset] ?? 0,
  }));

  // Find max absolute value for scaling bars
  const maxAbs = flows.reduce((m, f) => Math.max(m, Math.abs(f.value)), 1);

  return (
    <div className="stats-panel stats-etf-panel">
      <div className="stats-panel-header">
        <span className="stats-panel-title">{t('stats.etfFlows')}</span>
        {dateTabs.length > 1 && (
          <div className="stats-tf-tabs">
            {dateTabs.map((entry, i) => (
              <button
                key={entry.date}
                className={`stats-tf-tab ${selectedDateIdx === i ? 'active' : ''}`}
                onClick={() => setSelectedDateIdx(i)}
              >
                {formatDate(entry.date)}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="stats-etf-cols">
        {flows.map((f) => {
          const pct = (Math.abs(f.value) / maxAbs) * 50; // max 50% of container height
          const isPositive = f.value >= 0;

          return (
            <div key={f.asset} className="stats-etf-col">
              <span className="stats-etf-label">{f.asset}</span>
              <div className="stats-etf-chart">
                {/* Top half: positive bars */}
                <div className="stats-etf-half stats-etf-top">
                  {isPositive && f.value !== 0 && (
                    <div
                      className="stats-etf-bar positive"
                      style={{ height: `${pct}%` }}
                    />
                  )}
                </div>
                <div className="stats-etf-baseline" />
                {/* Bottom half: negative bars */}
                <div className="stats-etf-half stats-etf-bottom">
                  {!isPositive && f.value !== 0 && (
                    <div
                      className="stats-etf-bar negative"
                      style={{ height: `${pct}%` }}
                    />
                  )}
                </div>
              </div>
              <span className={`stats-etf-value ${isPositive ? 'c-green' : 'c-red'}`}>
                {f.value >= 0 ? '+' : ''}{formatVolume(f.value)}
              </span>
            </div>
          );
        })}
      </div>

      {selected?.date && (
        <div className="stats-etf-date">{selected.date}</div>
      )}
    </div>
  );
}

function formatDate(dateStr) {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length < 3) return dateStr;
  return `${parts[1]}/${parts[2]}`;
}

export default EtfFlowPanel;
